import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import './../../../../../../../sinapsi/style/price-calendar.sinapsi.css'
import './../style/rr-bulk-edit-cc.css'
import { compareDates } from 'src/utils/date'
import { ChargeCategoryFragment } from 'src/api/api.generated'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservedResourceF } from '../../../../../types/reservation-detail.types'

type RRBulkEditChargeCategoryGridHeaderProps = {
  day: Date
  chargeCategories: ChargeCategoryFragment[]
  reservedResources: ReservedResourceF[]
  disabled?: boolean
  updateRowsChargeCategory: (day: Date, chargeCategoryId: string | undefined) => void
}

const RESET_OPTION_KEY = 'RESET_OPTION_KEY'

export default function RRBulkEditChargeCategoryGridHeader(props: RRBulkEditChargeCategoryGridHeaderProps) {
  const { day, chargeCategories, disabled, reservedResources, updateRowsChargeCategory } = props
  const { t } = useTranslation()
  const formatDate = useFormatDate()
  const [selectedCC, setSelectedCC] = useState(RESET_OPTION_KEY)

  const rrChargeCategories = useMemo(() => {
    const ratesChargeCategories = reservedResources.map((rr) => rr.rate.chargesRate?.map((cr) => cr.chargeCategoryId).flat() ?? [])
    const tmpChargeCategories: string[] = []
    ratesChargeCategories.flat().forEach((cc) => {
      const enabledCC = (ratesChargeCategories.filter((a) => a.includes(cc)) ?? []).length === ratesChargeCategories.length
      if (enabledCC && !tmpChargeCategories.includes(cc)) {
        tmpChargeCategories.push(cc)
      }
    })
    return tmpChargeCategories
  }, [reservedResources])

  return (
    <>
      <span className="small-font">{formatDate(day, 'MMM y')}</span>
      <div className={compareDates(day, new Date()) === 0 ? 'today' : ''}>
        {formatDate(day, 'iii')} <strong>{formatDate(day, 'dd')}</strong>
      </div>
      <select
        style={{ width: '115px', marginTop: '8px' }}
        value={selectedCC}
        onChange={(event) => {
          const selectedCC = event.target.value
          setSelectedCC(selectedCC)
          if (selectedCC === RESET_OPTION_KEY) {
            updateRowsChargeCategory(day, undefined)
          } else {
            updateRowsChargeCategory(day, selectedCC)
          }
        }}
        disabled={disabled}
      >
        <option key={RESET_OPTION_KEY} value={RESET_OPTION_KEY}>
          {selectedCC === RESET_OPTION_KEY ? '' : t('commons.reset').toUpperCase()}
        </option>
        {chargeCategories
          .filter((cc) => rrChargeCategories.includes(cc.id))
          ?.map((cc) => {
            return (
              <option key={cc.id} value={cc.id}>
                {cc.name}
              </option>
            )
          })}
      </select>
    </>
  )
}
